module.exports = __webpack_public_path__ + "media/ad_preview/espn-6def45c9.png";